
<template>
  <div>
    <v-alert
      :value="true"
      :color="color"
      :type="type"
      outline
    >
      {{ message }}
    </v-alert>
  </div>
</template>

<script>
import { i18n } from '@/lang/';
import {
  VAlert
} from 'vuetify/lib';
export default {
  components: {
    VAlert
  },
  props: {
    color: {
      type: String,
      default: 'error'
    },
    type: {
      type: String,
      default: 'warning'
    },
    message: {
      type: String,
      default: i18n.tc('message.somethingWentWrong')
    }
  }
};
</script>

    <style>
</style>